import { useState } from "react";
import { Gauge, Radar, Layers, MoreHorizontal, X } from "lucide-react";

const DEFAULT_PRIMARY = [
  { id: "panel", label: "Panel", icon: Gauge },
  { id: "rsi", label: "RSI", icon: Radar },
  { id: "positions", label: "Pozisyonlar", icon: Layers },
];

export const BottomNav = ({ tabs, tab, setTab }) => {
  const [more, setMore] = useState(false);
  // yalnız bu uygulamada var olan sekmeler ana çubukta; 3'ten azsa kalan sekmelerle doldur
  const present = DEFAULT_PRIMARY.filter((p) => tabs.some((t) => t.id === p.id));
  const PRIMARY = [...present, ...tabs.filter((t) => !present.some((p) => p.id === t.id)).slice(0, Math.max(0, 3 - present.length))];
  const extra = tabs.filter((t) => !PRIMARY.some((p) => p.id === t.id));
  const moreActive = extra.some((t) => t.id === tab);
  const go = (id) => { setTab(id); setMore(false); window.scrollTo({ top: 0, behavior: "smooth" }); };

  return (
    <>
      {more && (
        <div data-testid="bottom-nav-more-sheet" className="sm:hidden fixed inset-0 z-[55] bg-black/60 backdrop-blur-sm" onClick={() => setMore(false)}>
          <div className="absolute inset-x-0 bottom-[64px] bg-[#121724] border-t border-[#2A364F] rounded-t-2xl p-4 pb-5 fade-up" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs font-bold uppercase tracking-wider text-[#64748B]">Diğer sayfalar</span>
              <button onClick={() => setMore(false)} className="text-[#64748B]"><X className="h-4 w-4" /></button>
            </div>
            <div className="grid grid-cols-3 gap-2">
              {extra.map((t) => {
                const Icon = t.icon; const active = tab === t.id;
                return (
                  <button key={t.id} data-testid={`bottom-nav-more-${t.id}`} onClick={() => go(t.id)}
                    className={`flex flex-col items-center gap-1.5 rounded-xl py-3 text-[11px] font-semibold border transition-colors ${active ? "border-[#3B82F6]/60 bg-[#3B82F6]/15 text-[#3B82F6]" : "border-[#1E2738] bg-[#0B0E17] text-[#94A3B8] active:bg-[#1A2032]"}`}>
                    <Icon className="h-5 w-5" /> {t.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}
      <nav data-testid="bottom-nav" className="sm:hidden fixed inset-x-0 bottom-0 z-[56] bg-[#0E1320]/95 backdrop-blur-md border-t border-[#1E2738]" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
        <div className="grid grid-cols-4 h-16">
          {PRIMARY.map((t) => {
            const Icon = t.icon; const active = tab === t.id && !more;
            return (
              <button key={t.id} data-testid={`bottom-nav-${t.id}`} onClick={() => go(t.id)}
                className={`relative flex flex-col items-center justify-center gap-1 text-[11px] font-semibold transition-colors ${active ? "text-[#3B82F6]" : "text-[#64748B] active:text-[#94A3B8]"}`}>
                {active && <span className="absolute top-0 h-0.5 w-8 rounded-full bg-[#3B82F6]" />}
                <Icon className={`h-5 w-5 transition-transform ${active ? "scale-110" : ""}`} /> {t.label}
              </button>
            );
          })}
          <button data-testid="bottom-nav-more" onClick={() => setMore((v) => !v)}
            className={`relative flex flex-col items-center justify-center gap-1 text-[11px] font-semibold transition-colors ${more || moreActive ? "text-[#3B82F6]" : "text-[#64748B] active:text-[#94A3B8]"}`}>
            {moreActive && !more && <span className="absolute top-0 h-0.5 w-8 rounded-full bg-[#3B82F6]" />}
            <MoreHorizontal className="h-5 w-5" /> Daha Fazla
          </button>
        </div>
      </nav>
    </>
  );
};
